import React from 'react';
import { Outlet } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { marketingUrl } from '../../lib/marketingUrls';
import Navbar from '../Navbar';

const PublicLayout: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="flex min-h-screen flex-col bg-muted">
      <Navbar variant="public" />
      <main className="mt-16 flex flex-1 flex-col">
        <div className="container mx-auto flex-1 px-4 py-6">
          <Outlet />
        </div>
        <div className="pb-6 text-center text-xs text-muted-foreground">
          <a href={marketingUrl('/about#privacy')} className="hover:text-foreground hover:underline">
            {t('privacyPolicy')}
          </a>
          <span className="mx-2">·</span>
          <a href={marketingUrl('/about#terms')} className="hover:text-foreground hover:underline">
            {t('termsOfService')}
          </a>
        </div>
      </main>
    </div>
  );
};

export default PublicLayout;
